import React from "react";
import styled from "styled-components";

const SubscoreContainer = styled.div`
  margin-bottom: 0.5rem;
`;

const SubscoreLabel = styled.span`
  font-size: 14px;
  color: #6b7280;
  margin-right: 8px;
`;

const SubscoreValue = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #374151;
`;

const SubscoreProgressBar = ({ category, index, t }) => {
  if (!category) return null;

  return (
    <SubscoreContainer>
      <SubscoreLabel>{category.name}:</SubscoreLabel>
      <SubscoreValue>{category.score || 0}</SubscoreValue>
    </SubscoreContainer>
  );
};

export default SubscoreProgressBar;
